import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errorText } from "@/lib/api";
import { AuthLayout } from "@/components/brand/AuthLayout";
import { Field, FormError, FormSuccess } from "@/components/brand/Field";

export default function ResetPassword({ admin = false }) {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const min = admin ? 12 : 10;
  const base = admin ? "/admin/auth" : "/auth";

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < min) return setError(`Use at least ${min} characters.`);
    setBusy(true); setError("");
    try {
      await api.post(`${base}/reset-password`, { token: params.get("token"), password });
      setMsg("Your password has been changed. You can sign in now.");
    } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout admin={admin} title="Choose a new password"
      footer={<Link className="ts-link" to={admin ? "/admin/login" : "/signin"} data-testid="reset-signin-link">Go to sign in</Link>}>
      <form onSubmit={submit} noValidate>
        <FormSuccess message={msg} testId="reset-success" />
        <FormError message={error} testId="reset-error" />
        {!msg && (
          <>
            <Field id="password" label="New password" hint={`At least ${min} characters.`}>
              <input id="password" data-testid="reset-password-input" className="ts-input" type="password" autoComplete="new-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </Field>
            <button data-testid="reset-submit-button" className="ts-btn ts-btn-primary w-full" disabled={busy}>{busy ? "Saving…" : "Save new password"}</button>
          </>
        )}
      </form>
    </AuthLayout>
  );
}
